import { render, staticRenderFns } from "./_purgeTeam.vue?vue&type=template&id=2c0c3884&scoped=true&lang=pug&"
import script from "./_purgeTeam.vue?vue&type=script&lang=js&"
export * from "./_purgeTeam.vue?vue&type=script&lang=js&"
import style0 from "./_purgeTeam.vue?vue&type=style&index=0&id=2c0c3884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c3884",
  null
  
)

export default component.exports